import type { SyncProgressConfig, LocalStorageKeys } from "../types/sync-progress"

export const SYNC_CONFIG: SyncProgressConfig = {
  minProgressIncrement: 5,
  maxProgressIncrement: 20,
  updateInterval: 800,
  totalRecords: 100,
}

export const STORAGE_KEYS: LocalStorageKeys = {
  SYNCING_STATUS: "syncing-status",
  HUBSPOT_CONNECTED: "hubspot_connected",
  MODIFY_SYNC_CONFIGURATION: "modifysyncConfiguration",
  SALESFORCE_CONNECTED: "salesforce_connected",
  SYNC_CONFIGURATION: "syncConfiguration",
  FIELD_MAPPINGS: "fieldMappings",
  CONNECTOR_FLOW_STEP: "connectorFlowStep",
  SYNC_COMPLETED: "syncCompleted",
  SELECTED_CONNECTOR: "selectedConnector",
  SELECTED_SYNC_OPTION: "selectedSyncOption",
  TARGET_OBJECT: "target_object",
  SOURCE_OBJECT: "source_object"
}

export const STATUS_ICONS = {
  initializing: "🔄",
  syncing: "⚡",
  completed: "✅",
  error: "❌",
} as const

export const STATUS_COLORS = {
  completed: "#28a745",
  error: "#dc3545",
  default: "#007bff",
} as const

export const ROUTES = {
  DASHBOARD: "/dashboard",
  SYNC_LOGS: "/dashboard/sync-logs",
} as const
